"use strict" /* eslint-disable no-console */;

import Vue from "vue";
import Vuex from "vuex";
/** @see https://vee-validate.logaretm.com/v2/api/data-attrs.html */
import VeeValidate from "vee-validate";
import store from "./vuex/store.js";
import LottieVuePlayer from "@lottiefiles/vue-lottie-player";

import Comments from "Components/Comments.vue";
import HeaderSearch from "Components/HeaderSearch.vue";

import ImpersonateUser from "Components/ImpersonateUser.vue";
import Utilitynav from "Components/Utilitynav.vue";
import UtilitynavMobile from "Components/UtilitynavMobile.vue";
import MobileUtility from "Components/MobileUtility.vue";
import Myaccount from "Components/Myaccount.vue";
import Login from "Components/Login.vue";
import LoginModal from "Components/LoginModal.vue";
import MobileLogin from "Components/MobileLogin.vue";
import ShoppingCart from "Components/ShoppingCart.vue";
import MiniCart from "Components/MiniCart.vue";
import CartTotal from "Components/CartTotal.vue";
import CartSuggested from "Components/CartSuggested.vue";
import CartSubmit from "Components/CartSubmit.vue";
import AddToCart from "Components/AddToCart.vue";
import AddToCartButton from "Components/AddToCartButton.vue";
import ConcordReader from "Components/ConcordReader.vue";
// import AddToWishlist from 'Components/AddToWishlist.vue';
const AddToWishlist = () => ({
  // The component to load (should be a Promise)
  component: import("Components/AddToWishlist.vue"),
  // A component to use while the async component is loading
  loading: null,
  // A component to use if the load fails
  error: null,
});
import CatalogFilters from "Components/CatalogFilters.vue";
import CatalogHero from "Components/CatalogHero.vue";
import CatalogResults from "Components/CatalogResults.vue";
import CatalogActiveFilters from "Components/CatalogActiveFilters.vue";
import CatalogSearch from "Components/CatalogSearch.vue";
import HomeSearch from "Components/HomeSearch.vue";
import SearchResults from "Components/SearchResults.vue";
// import HeroSearch from 'Components/HeroSearch.vue';
import GlobalSearch from "Components/GlobalSearch.vue";
import GlobalSearchResults from "Components/GlobalSearchResults.vue";
import GlobalSearchNoResults from "Components/GlobalSearchNoResults.vue";
import GlobalSearchPerformResults from "Components/GlobalSearchPerformResults.vue";
import GlobalSearchShopResults from "Components/GlobalSearchShopResults.vue";
import GlobalSearchAuthorResults from "Components/GlobalSearchAuthorResults.vue";
import LandingSearch from "Components/LandingSearch.vue";
import NotifyMe from "Components/NotifyMe.vue";
import ProductVariants from "Components/ProductVariants.vue";
import VariantIsbn from "Components/VariantIsbn.vue";
import VariantPublisher from "Components/VariantPublisher.vue";
import PriceRange from "Components/PriceRange.vue";
import PriceRangeProduct from "Components/PriceRangeProduct.vue";
import FooterMenuLogin from "Components/FooterMenuLogin.vue";
import DashboardTabs from "Components/DashboardTabs.vue";
import ReadMore from "Components/ReadMore.vue";
import InlineModal from "Components/InlineModal.vue";
// import LicenceEstimator from "Components/Estimator/LicenceEstimator.vue";
const LicenceEstimator = () => ({
  // The component to load (should be a Promise)
  component: import("Components/Estimator/LicenceEstimator.vue"),
  // A component to use while the async component is loading
  loading: null,
  // A component to use if the load fails
  error: null,
});
import AsyncTemplate from "./async-template";
import HomeLoader from "Components/HomeLoader.vue";
import VueMeta from "vue-meta";

const vueStuff = (function() {
  window.Vue = Vue;
  Vue.use(Vuex);
  Vue.use(VeeValidate);
  Vue.use(VueMeta);
  Vue.use(LottieVuePlayer);

  /**
   * Next, we will create a fresh Vue application instance and attach it to
   * the page. Then, you may begin adding components to this application
   * or customize the JavaScript scaffolding to fit your unique needs.
   */

  // eslint-disable-next-line
  const app = new Vue({
    el: "#app",
    store,
    components: {
      LicenceEstimator,
      ReadMore,
      InlineModal,
      AsyncTemplate,
      ProductVariants,
      Comments,
      MiniCart,
      ShoppingCart,
      CartTotal,
      CartSuggested,
      CartSubmit,
      AddToCart,
      AddToCartButton,
      ConcordReader,
      NotifyMe,
      Utilitynav,
      UtilitynavMobile,
      MobileUtility,
      Myaccount,
      Login,
      LoginModal,
      MobileLogin,
      HeaderSearch,
      AddToWishlist,
      CatalogFilters,
      CatalogHero,
      CatalogResults,
      CatalogActiveFilters,
      CatalogSearch,
      HomeSearch,
      SearchResults,
      // HeroSearch,
      GlobalSearch,
      GlobalSearchResults,
      GlobalSearchNoResults,
      GlobalSearchPerformResults,
      GlobalSearchShopResults,
      GlobalSearchAuthorResults,
      LandingSearch,
      VariantIsbn,
      VariantPublisher,
      PriceRange,
      PriceRangeProduct,
      ImpersonateUser,
      FooterMenuLogin,
      DashboardTabs,
      HomeLoader,
      // QuickViewModal: () => import('Components/QuickViewModal.vue'),
      QuickViewModal: () => ({
        // The component to load (should be a Promise)
        component: import(
          /* webpackChunkName: "components/QuickViewModal" */
          "Components/QuickViewModal.vue"
        ),
        // A component to use while the async component is loading
        loading: import("Components/Loading.vue"),
        // A component to use if the load fails
        error: null,
        // Delay before showing the loading component. Default: 200ms.
        delay: 1000,
        // The error component will be displayed if a timeout is
        // provided and exceeded. Default: Infinity.
        timeout: 3000,
      }),
    },
    data: {
      guest: window.loggedIn,
      // estimateModalOpen: false,
    },
  });

  // const messages = {
  //   en: {
  //     location: () =>{
  //       return "Your password is not confirmed"
  //     },
  //   }
  // };

  // app.$validator.updateDictionary(messages);
})();

export default vueStuff;



// WEBPACK FOOTER //
// ./resources/assets/js/vue-stuff.js